import { Component } from '@angular/core';
import {AuthServiceService} from './auth/auth-service.service';
import {AngularFireAuth} from '@angular/fire/auth';
import * as firebase from 'firebase';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'FEC';
  logged;

  constructor(public authenticationService: AuthServiceService, private afAuth: AngularFireAuth) {
    this.isLoggedIn();
  }

  isLoggedIn() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.logged = true;
      } else {
        this.logged = false;
      }
    });
  }

  signOut() {
    this.authenticationService.SignOut();
  }
}

